import { render, staticRenderFns } from "./SubjectListItem.vue?vue&type=template&id=13ffb595&scoped=true&lang=pug"
import script from "./SubjectListItem.vue?vue&type=script&lang=js"
export * from "./SubjectListItem.vue?vue&type=script&lang=js"
import style0 from "./SubjectListItem.vue?vue&type=style&index=0&id=13ffb595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffb595",
  null
  
)

export default component.exports